module.exports = __webpack_public_path__ + "img/Frame 27.ae13d289.png";